const DropDownArrow = ({ width, height, fill }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.475 4.475L0.849997 0.85C0.799997 0.8 0.762497 0.745833 0.737497 0.6875C0.712497 0.629167 0.699997 0.566667 0.699997 0.5C0.699997 0.366667 0.74583 0.25 0.837497 0.15C0.929164 0.05 1.05 0 1.2 0H8.8C8.95 0 9.07083 0.05 9.1625 0.15C9.25416 0.25 9.3 0.366667 9.3 0.5C9.3 0.533333 9.25 0.65 9.15 0.85L5.525 4.475C5.44166 4.55833 5.35833 4.61667 5.275 4.65C5.19166 4.68333 5.1 4.7 5 4.7C4.9 4.7 4.80833 4.68333 4.725 4.65C4.64166 4.61667 4.55833 4.55833 4.475 4.475Z"
        fill={fill}
      />
    </svg>
  );
};

DropDownArrow.defaultProps = {
  width: 10,
  height: 5,
  fill: "#9d7987",
};

export default DropDownArrow;
